module.exports = __webpack_public_path__ + "img/record-play.cf8779f7.png";